import { __decorate, __metadata } from "tslib";
import { getTenantId } from "@/store/helper";
import { GuidItemModel } from "../models/shared/guidItem";
import { TagGridViewModel } from "../models/tag/tagListing";
import { IPMOTagDTO, PMOTagModel } from "../models/tag/PMOTag";
import { IPMOTagSearchDataListingDTO, PMOTagSearchDataModel } from "../models/tag/PMOTagSearchListingDTO";
import store from "..";
import _ from "lodash";
import { Guid } from "guid-typescript";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { Vue } from "vue-property-decorator";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { TeamGridViewModel } from "../models/teams/teamList";
import { TagReportRequestModel } from "../models/tag/tagReportRequest";
import { PMOTagReportModel } from "../models/tag/PMOTagReportDTO";
let TagsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    let TagsModule = class TagsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "tag";
            this.tagSelections = [];
            this.allTagsForDefault = [];
            this.tagGridViewEntries = [];
            this.tagDetailEntries = new PMOTagModel();
            this.totalTags = 0;
            this.searchParams = null;
            this.teams = [];
            this.activeTeams = [];
            this.tagReport = [];
        }
        async GetTeams() {
            var url = `${getTenantId()}/${this.apiNode}/teams`;
            let { data } = await service.get(url);
            if (data) {
                this.GetTeamList(plainToClass(TeamGridViewModel, data.teams));
                return data;
            }
        }
        async GetTags() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                return data;
            }
        }
        async GetTagListings(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                //console.log(data.pmoTags);
                this.SetTagListingEntries(plainToClass(TagGridViewModel, data.pmoTags));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        async SetTotalCount(totalCount) {
            this.totalTags = totalCount;
        }
        async GetTagDetailById(tagId) {
            var url = `${getTenantId()}/${this.apiNode}/${tagId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetTagDetailEntries(plainToClass(PMOTagModel, data.tag));
                return data;
            }
        }
        async CreateTag(tag) {
            var url = `${getTenantId()}/${this.apiNode}/create`;
            let { data } = await service.post(url, tag);
            if (data) {
                return data;
            }
        }
        async UpdateTag(tag) {
            var url = `${getTenantId()}/${this.apiNode}/update`;
            let { data } = await service.put(url, tag);
            if (data) {
                return data;
            }
        }
        async DeleteTagById(tagId) {
            var url = `${getTenantId()}/${this.apiNode}/` + tagId + "/delete";
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async GetTeamsForTagsReport() {
            var url = `${getTenantId()}/${this.apiNode}/teams/report`;
            let { data } = await service.get(url);
            if (data) {
                this.SetTeams(plainToClass(GuidItemModel, data.teams));
                return data;
            }
        }
        async GetTagsByTeamId(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/tags/${teamId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetTags(plainToClass(GuidItemModel, data.tags));
                return data;
            }
        }
        async GetTagReport(payload) {
            var url = `${getTenantId()}/${this.apiNode}/report`;
            let { data } = await service.post(url, payload);
            if (data) {
                this.SetTagReport(plainToClass(PMOTagReportModel, data.tagReport));
                return data;
            }
        }
        async GetTagReportAsExcel(payload) {
            var url = `${getTenantId()}/${this.apiNode}/Excel/tagReport`;
            let { data } = await service.post(url, payload, { responseType: "blob" });
            return data;
        }
        SetTagReport(tagReport) {
            this.tagReport = tagReport;
        }
        ClearReport() {
            this.tagReport = [];
        }
        SetTeams(teams) {
            this.activeTeams = teams;
        }
        SetTags(tags) {
            this.allTagsForDefault = tags;
        }
        GetTeamList(teams) {
            this.teams = teams;
        }
        ClearTagDetails() {
            for (const key in this.tagDetailEntries) {
                if (this.tagDetailEntries.hasOwnProperty(key)) {
                    if (typeof this.tagDetailEntries[key] === "number") {
                        Vue.set(this.tagDetailEntries, key, 0);
                    }
                    else if (typeof this.tagDetailEntries[key] === "boolean") {
                        Vue.set(this.tagDetailEntries, key, false);
                    }
                    else if (Array.isArray(this.tagDetailEntries[key])) {
                        Vue.set(this.tagDetailEntries, key, []);
                    }
                    else {
                        Vue.set(this.tagDetailEntries, key, "");
                    }
                }
            }
        }
        SetTagListingEntries(entries) {
            this.tagGridViewEntries = entries;
        }
        SetTagDetailEntries(entries) {
            // const { tasks, ...sourceWithoutTasks } = entries;
            // Object.assign(this.projectTagDetailEntries, sourceWithoutTasks);
        }
        AssignSearchParams(params) {
            this.searchParams = _.cloneDeep(params);
        }
        ClearSearchParams() {
            this.searchParams = null;
        }
        ClearDefaultTags() {
            this.allTagsForDefault = [];
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], TagsModule.prototype, "GetTeams", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], TagsModule.prototype, "GetTags", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof IPMOTagSearchDataListingDTO !== "undefined" && IPMOTagSearchDataListingDTO) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], TagsModule.prototype, "GetTagListings", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], TagsModule.prototype, "SetTotalCount", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof Guid !== "undefined" && Guid) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], TagsModule.prototype, "GetTagDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof PMOTagModel !== "undefined" && PMOTagModel) === "function" ? _g : Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], TagsModule.prototype, "CreateTag", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof IPMOTagDTO !== "undefined" && IPMOTagDTO) === "function" ? _j : Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], TagsModule.prototype, "UpdateTag", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof Guid !== "undefined" && Guid) === "function" ? _l : Object]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], TagsModule.prototype, "DeleteTagById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], TagsModule.prototype, "GetTeamsForTagsReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
    ], TagsModule.prototype, "GetTagsByTeamId", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_q = typeof TagReportRequestModel !== "undefined" && TagReportRequestModel) === "function" ? _q : Object]),
        __metadata("design:returntype", typeof (_r = typeof Promise !== "undefined" && Promise) === "function" ? _r : Object)
    ], TagsModule.prototype, "GetTagReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_s = typeof TagReportRequestModel !== "undefined" && TagReportRequestModel) === "function" ? _s : Object]),
        __metadata("design:returntype", typeof (_t = typeof Promise !== "undefined" && Promise) === "function" ? _t : Object)
    ], TagsModule.prototype, "GetTagReportAsExcel", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "SetTagReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "ClearReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "SetTeams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "SetTags", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "GetTeamList", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "ClearTagDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "SetTagListingEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_u = typeof IPMOTagDTO !== "undefined" && IPMOTagDTO) === "function" ? _u : Object]),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "SetTagDetailEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_v = typeof PMOTagSearchDataModel !== "undefined" && PMOTagSearchDataModel) === "function" ? _v : Object]),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "AssignSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "ClearSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "ClearDefaultTags", null);
    TagsModule = __decorate([
        Module({ dynamic: true, store: store, name: "tags", namespaced: true })
    ], TagsModule);
    return TagsModule;
})();
export const TagModule = getModule(TagsModule);
